export default [
    {
        path: '/admin/hr/shifts',
        name: 'shift',
        meta: { requiresAuth: true },
        component: () => import('@/pages/human-resource/shift/index.vue')
    }
]
